module.exports = __webpack_public_path__ + "static/logo800-5fcc2d3685c0da761748ed4079903038.png";